import type { Key9Puzzle } from '../types/puzzle';

export type FullSudokuPlacement = {
  board: string[];
  changed: boolean;
  completed: boolean;
};

export function createFullBoard(puzzle: Key9Puzzle, lockedCells: Map<number, number>): string[] {
  const board = puzzle.puzzle.split('');
  lockedCells.forEach((digit, cellIndex) => {
    board[cellIndex] = String(digit);
  });
  return board;
}

export function placeFullDigit(
  puzzle: Key9Puzzle,
  board: string[],
  lockedCells: Set<number>,
  cellIndex: number,
  digit: number
): FullSudokuPlacement {
  if (lockedCells.has(cellIndex) || puzzle.puzzle[cellIndex] !== '0') {
    return {
      board: [...board],
      changed: false,
      completed: isFullSudokuComplete(puzzle, board)
    };
  }

  const nextBoard = [...board];
  nextBoard[cellIndex] = digit === 0 ? '0' : String(digit);

  return {
    board: nextBoard,
    changed: nextBoard[cellIndex] !== board[cellIndex],
    completed: isFullSudokuComplete(puzzle, nextBoard)
  };
}

export function isFullSudokuComplete(puzzle: Key9Puzzle, board: string[]): boolean {
  return board.join('') === puzzle.solution;
}
